var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.186285 4.89503C1.43112 1.68378 5.04312 0.0901119 8.25379 1.33495C9.88775 1.96855 11.1797 3.26048 11.8133 4.89444C11.8397 4.96236 11.8397 5.03769 11.8133 5.10561C10.5685 8.31628 6.95645 9.90994 3.74579 8.66511C2.11182 8.0315 0.819892 6.73958 0.186285 5.10561C0.15991 5.03769 0.15991 4.96236 0.186285 4.89444V4.89503ZM3.95636 8.12087C6.83161 9.23562 10.0615 7.8397 11.2276 5.00004C10.6385 3.56726 9.48708 2.43907 8.04261 1.8792C5.16852 0.764452 1.93861 2.16037 0.772523 5.00004C1.36167 6.43282 2.51305 7.561 3.95752 8.12087H3.95636ZM5.9998 7.33338C4.71114 7.33338 3.66647 6.28871 3.66647 5.00004C3.66647 3.71138 4.71114 2.66671 5.9998 2.66671C7.28846 2.66671 8.33313 3.71138 8.33313 5.00004C8.33313 6.28871 7.28846 7.33338 5.9998 7.33338ZM5.9998 6.75004C6.9663 6.75004 7.7498 5.96654 7.7498 5.00004C7.7498 4.03354 6.9663 3.25004 5.9998 3.25004C5.0333 3.25004 4.2498 4.03354 4.2498 5.00004C4.2498 5.96654 5.0333 6.75004 5.9998 6.75004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.eb8581f9ba755a58f5df9a937378d24f.svg";
export { ForwardRef as ReactComponent };